import authenticatedHttpClient from '@frontend/api/http';
import { FontSize } from '@frontend/atoms/appearanceAtom';
import { OPAL_BACKEND_URL } from '@frontend/envConfig';

export type AuthStatusInstanceDetails = {
  instance_id: string;
  customer_id: string;
  master_customer_id: string;
  cmp_org_sso_id: string;
  product_id: string;
  product_sku: string;
  hosted_region?: string;
  operations: Array<{ name: string; allowed: boolean }>;
  connected_opal_instance_id: string;
};

export type AuthStatusResponse = {
  id: string;
  email: string;
  name: string;
  customer_id: string;
  master_customer_id: string;
  cmp_org_sso_id: string;
  product_scope: string;
  instance_details: AuthStatusInstanceDetails;
  user_preferences?: { font_size: FontSize };
};

export const getAuthStatus = async (instanceId: string): Promise<AuthStatusResponse> => {
  const response = await authenticatedHttpClient.get<AuthStatusResponse>(
    `${OPAL_BACKEND_URL}/api/v1/auth/status`,
    { params: { instance_id: instanceId } }
  );
  return response.data;
};
